import React from "react";
import { StyleProp, StyleSheet, TextStyle } from "react-native";
import Text from "./Text";

type HeadlineProps = {
    style?: StyleProp<TextStyle>;
    children?: React.ReactNode;
    h?: HeadlineSize;
};

const styles = StyleSheet.create({
    text: {
        fontSize: 40,
        fontWeight: "bold",
        alignSelf: "flex-start",
    },
});

export type HeadlineSize = "1" | "2" | "3" | "4";

const HEADLINE_STYLES: Record<HeadlineSize, TextStyle> = {
    1: {
        fontSize: 40,
        fontWeight: "bold",
        textTransform: "uppercase",
    },
    2: {
        fontSize: 20,
        fontWeight: "bold",
        textTransform: "uppercase",
    },
    3: {
        fontSize: 16,
        fontWeight: "bold",
        textTransform: "uppercase",
    },
    4: {
        fontSize: 14,
        fontWeight: "bold",
        textTransform: "uppercase",
    },
};

const Headline: React.FC<HeadlineProps> = ({ style, children, h = "1" }) => (
    <Text allowFontScaling={false} style={[styles.text, HEADLINE_STYLES[h], style]}>
        {children}
    </Text>
);

export default Headline;
